// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-actions-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.article-action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--bg-tertiary);
  border: 2px solid var(--border-color);
  color: var(--text-primary);
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.article-action-btn:hover {
  border-color: var(--accent-primary);
  background: var(--accent-primary);
  color: white;
  transform: translateY(-2px);
}

.article-action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.article-action-btn svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.article-action-btn.voted {
  border-color: var(--accent-primary);
  background: var(--bg-tertiary);
}

.article-action-btn.reply-btn:hover {
  opacity: 0.9;
}

/* Vote Slider Popup */
.article-vote-slider-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  border-radius: 12px;
  padding: 24px;
  z-index: 1000;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  min-width: 320px;
}

.slider-header {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 16px;
  text-align: center;
}

.slider-container {
  margin: 20px 0;
}

.vote-slider {
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: var(--bg-tertiary);
  outline: none;
  cursor: pointer;
}

.vote-slider::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--accent-primary);
  cursor: pointer;
}

.vote-slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--accent-primary);
  cursor: pointer;
  border: none;
}

.slider-actions {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.slider-actions button {
  flex: 1 1;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid var(--border-color);
}

.cancel-btn {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.cancel-btn:hover {
  border-color: var(--accent-primary);
}

.vote-btn {
  padding: 12px 20px;
    background: var(--bg-secondary);
    border: 2px solid var(--border-color);
    color: var(--text-primary);
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.vote-btn:hover {
  opacity: 0.9;
}

.vote-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 640px) {
  .article-actions-bar {
    justify-content: center;
  }

  .article-action-btn {
    flex: 1 1;
    min-width: 100px;
    justify-content: center;
  }
}

/* Action dropdown menu */
.article-actions-bar .action-dropdown-wrapper {
  position: relative;
  display: inline-block;
}

.article-actions-bar .dropdown-toggle {
  font-size: 1.2rem;
  line-height: 1;
  padding: 8px 12px;
}

.article-actions-bar .action-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 6px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  z-index: 100;
  min-width: 170px;
  padding: 6px 0;
}

.article-actions-bar .action-dropdown-menu .dropdown-item {
  display: block;
  width: 100%;
  padding: 8px 14px;
  background: none;
  border: none;
  text-align: left;
  color: var(--text-secondary);
  font-size: 13px;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  box-sizing: border-box;
  font-family: inherit;
}

.article-actions-bar .action-dropdown-menu .dropdown-item:hover {
  background: var(--hover-bg);
  color: var(--primary-color);
}

.article-actions-bar .action-dropdown-menu .dropdown-item.dropdown-item-disabled,
.article-actions-bar .action-dropdown-menu .dropdown-item.dropdown-item-disabled:hover {
  cursor: not-allowed;
  color: var(--text-tertiary);
  background: transparent;
  opacity: 0.8;
}

.article-actions-bar .copy-link-notice {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  padding: 6px 10px;
  border-radius: 8px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  color: var(--text-primary);
  white-space: nowrap;
  z-index: 110;
}
`, "",{"version":3,"sources":["webpack://./src/components/ArticleActions/ArticleActions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;IAChB,+BAA+B;IAC/B,qCAAqC;IACrC,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,wCAAwC;EACxC,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".article-actions-bar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.article-action-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  background: var(--bg-tertiary);\r\n  border: 2px solid var(--border-color);\r\n  color: var(--text-primary);\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.article-action-btn:hover {\r\n  border-color: var(--accent-primary);\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.article-action-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n}\r\n\r\n.article-action-btn svg {\r\n  width: 20px;\r\n  height: 20px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.article-action-btn.voted {\r\n  border-color: var(--accent-primary);\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.article-action-btn.reply-btn:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n/* Vote Slider Popup */\r\n.article-vote-slider-popup {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background: var(--bg-secondary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  z-index: 1000;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\r\n  min-width: 320px;\r\n}\r\n\r\n.slider-header {\r\n  font-size: 1.1rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin-bottom: 16px;\r\n  text-align: center;\r\n}\r\n\r\n.slider-container {\r\n  margin: 20px 0;\r\n}\r\n\r\n.vote-slider {\r\n  width: 100%;\r\n  height: 6px;\r\n  border-radius: 3px;\r\n  background: var(--bg-tertiary);\r\n  outline: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.vote-slider::-webkit-slider-thumb {\r\n  appearance: none;\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  background: var(--accent-primary);\r\n  cursor: pointer;\r\n}\r\n\r\n.vote-slider::-moz-range-thumb {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  background: var(--accent-primary);\r\n  cursor: pointer;\r\n  border: none;\r\n}\r\n\r\n.slider-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.slider-actions button {\r\n  flex: 1;\r\n  padding: 12px 20px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 0.95rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  border: 2px solid var(--border-color);\r\n}\r\n\r\n.cancel-btn {\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.cancel-btn:hover {\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.vote-btn {\r\n  padding: 12px 20px;\r\n    background: var(--bg-secondary);\r\n    border: 2px solid var(--border-color);\r\n    color: var(--text-primary);\r\n    border-radius: 8px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n    text-decoration: none;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.vote-btn:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n.vote-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 640px) {\r\n  .article-actions-bar {\r\n    justify-content: center;\r\n  }\r\n\r\n  .article-action-btn {\r\n    flex: 1;\r\n    min-width: 100px;\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n/* Action dropdown menu */\r\n.article-actions-bar .action-dropdown-wrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.article-actions-bar .dropdown-toggle {\r\n  font-size: 1.2rem;\r\n  line-height: 1;\r\n  padding: 8px 12px;\r\n}\r\n\r\n.article-actions-bar .action-dropdown-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0;\r\n  margin-top: 6px;\r\n  background: var(--bg-primary);\r\n  border: 1px solid var(--border-color);\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\r\n  border-radius: 8px;\r\n  z-index: 100;\r\n  min-width: 170px;\r\n  padding: 6px 0;\r\n}\r\n\r\n.article-actions-bar .action-dropdown-menu .dropdown-item {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 8px 14px;\r\n  background: none;\r\n  border: none;\r\n  text-align: left;\r\n  color: var(--text-secondary);\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  white-space: nowrap;\r\n  box-sizing: border-box;\r\n  font-family: inherit;\r\n}\r\n\r\n.article-actions-bar .action-dropdown-menu .dropdown-item:hover {\r\n  background: var(--hover-bg);\r\n  color: var(--primary-color);\r\n}\r\n\r\n.article-actions-bar .action-dropdown-menu .dropdown-item.dropdown-item-disabled,\r\n.article-actions-bar .action-dropdown-menu .dropdown-item.dropdown-item-disabled:hover {\r\n  cursor: not-allowed;\r\n  color: var(--text-tertiary);\r\n  background: transparent;\r\n  opacity: 0.8;\r\n}\r\n\r\n.article-actions-bar .copy-link-notice {\r\n  position: absolute;\r\n  top: calc(100% + 6px);\r\n  right: 0;\r\n  padding: 6px 10px;\r\n  border-radius: 8px;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\r\n  font-size: 12px;\r\n  color: var(--text-primary);\r\n  white-space: nowrap;\r\n  z-index: 110;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
